import "./rank-service.css";

export const createRankService = () => {};
